var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submission != null)?_c('div',{staticClass:"TemplateViewEmail"},[_c('TemplateSubmissionInfo'),_c('EmailTextAreaCopy',{attrs:{"mail":_vm.mail}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }